import chalk from "chalk";

export const c = {
	heading: chalk.bold,
	command: chalk.bold,
	description: chalk.dim,
	flag: chalk.yellow,
	tableHeader: chalk.bold,
	separator: chalk.dim,
	number: chalk.dim,
	muted: chalk.dim,
	id: chalk.cyan,
	link: chalk.cyan.underline,
	success: chalk.green,
	error: chalk.red.bold,
};
